import './cms.css';
import Pages from './pages';
import Params from './parameters';
import Assets from './assets';
import Authenticated from '../lib/authenticated';
import Template from '../cms-templates/template';
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { isMobile } from 'react-device-detect';

function Panel({panel, page, setPage}) {
    switch (panel) {
        case 'pages':
            return <Pages currentPage={page} fnSetCurrentPage={setPage} />;
        case 'params':
            return <Params currentPage={page} fnSetCurrentPage={setPage} />;
        case 'assets':
            return <Assets currentPage={page} fnSetCurrentPage={setPage} />;
        default:
            return  <h1>Loading...</h1>;
    }
}

function DisableOnMobile({children}) {
    return isMobile ? <h1>CMS editing is not available on mobile devices,<br/> due to screen size constraints.</h1> : <>{children}</>
}

export default function Cms() {
    const [panel, setPanel] = useState('pages');
    const [page, setPage] = useState(null);

    return <Authenticated>
        <DisableOnMobile>
            <div className='cms'>
                <div className='panel'>
                    <nav>
                        <Link to='#pages' onClick={() => setPanel('pages')}>pages</Link>
                        <Link to='#params' onClick={() => setPanel('params')}>parameters</Link>
                        <Link to='#assets' onClick={() => setPanel('assets')}>assets</Link>
                    </nav>
                    <div className='sub-panel'>
                        <Panel panel={panel} page={page} setPage={setPage} />
                    </div>
                </div>
                <main>
                    {page !== null ? <Template id={page.id} handleLayout={false} /> : <h1>Select a page</h1>}
                </main>
            </div>
        </DisableOnMobile>
    </Authenticated>
}
